'use strict';

var React = require('react');
var ReactDOM = require('react-dom');
var _ = require('underscore');

var Top = require('./Top.jsx');
var Bottom = require('./Bottom.jsx');
var Middle = require('./Middle.jsx');
var Popup = require('./Popup.jsx');
var SelectComp = require('../common/SelectComp');

var PopupHelper = require('./../../interactive/PopupHelper');
var interactiveManager = require('./../../interactive/InteractiveManager');

var appTypes = require('../../types/appTypes');
var InteractiveType = require('../../interactive/InteractiveTypes.js');
var pageHelper = require('./../../helper/pageHelper.js');
var linkHelper = require('../../helper/linkHelper');
var comHelper = require('../../helper/componentHelper.js');
var dataHelper = require('../../helper/dataHelper');
var styleHelper = require('../../helper/styleHelper');

var timeLogHelper = require('../../helper/timeLogHelper');
var RunTimeOptions = require('../RuntimeOption');

var propConst = require('../../constants/propConst');

var Page = React.createClass({
  propTypes: {
    page: React.PropTypes.object.isRequired,
    size: React.PropTypes.shape({
      width: React.PropTypes.number,
      height: React.PropTypes.number
    }).isRequired,
    domSize: React.PropTypes.shape({
      width: React.PropTypes.number,
      height: React.PropTypes.number
    }),
    canFix: React.PropTypes.bool.isRequired,
    appOrientation: React.PropTypes.string,
    onLinkClick: React.PropTypes.func.isRequired,
    onShowRemark: React.PropTypes.func.isRequired
  },
  getInitialState: function () {
    return {
      page: this.props.page,
      isShowSelectExpand: false,
      pageScrollTop: 0
    };
  },

  componentWillMount: function () {
    this.startMount = Date.now();
  },

  oldPageID: null,
  componentWillReceiveProps: function (nextProps) {
    if(this.oldPageID !== nextProps.page.ID) {      //切换页面时，重置弹出面板的载入交互数组
      this.loadedPopupArray = [];
      this.oldPageID = nextProps.page.ID;
    }
    this.setState({
      page: nextProps.page
    });
  },

  componentDidUpdate: function () {
    if (this.state.transitions) {
      this.state.transitions.forEach(function (transition) {
        $('#' + transition.id).css({
          left: 0,
          top: 100
        }).transition(transition.animation);
      });
    }
    // this.startAllLoadInteractive(false);
  },

  componentDidMount: function () {
  },

  isLoaded: false,
  isLoadInteractiveStart: false,

  startAllLoadInteractive: function (isCreate) {
    this.isLoaded = this.props.isLoaded;
    if (this.isLoaded && !this.isLoadInteractiveStart) {
      this.isLoadInteractiveStart = true;
    } else {
      return;
    }
    if (!this.state.page.controls.control) {
      return;
    }
    /*var self = this;

    var fx = function (items) {
      var comp;
      var i;
      for (i = 0; i < items.length; i++) {
        comp = items[i];
        if (pageHelper.IsInvisualInteractiveCom(comp.controlTypeID)) {
          comp.onOpened = self.doPopupOpened;
          continue;
        }
        self.doStartCompLoadInteractive(comp);
        if (comp.items) {
          fx(comp.items);
        }
      }
    };*/

    interactiveManager.reset();

    this.startControlLoadInteractive(this.state.page.controls.control, false);
  },

  startControlLoadInteractive: function(items) {
    var comp;
    var i;
    for (i = 0; i < items.length; i++) {
      comp = items[i];

      this.startCompLoadInteractive(comp);
    }
  },

  startLoadContentInteractive: function(contentPanel) {
    var index = styleHelper.getInt(contentPanel, propConst.SELECTED_INDEX);
    this.startCompLoadInteractive(contentPanel.items[index]);
  },

  startCompLoadInteractive: function(comp) {
    var isLoadContent = false;
    if(comp.controlTypeID === 'ContentPanel') {
      isLoadContent = true;
    }
    if (pageHelper.IsInvisualInteractiveCom(comp.controlTypeID)) {
      comp.onOpened = this.doPopupOpened;
      return;
    }
    this.doStartCompLoadInteractive(comp);
    if(isLoadContent) {
      this.startLoadContentInteractive(comp)
    } else if (comp.items) {
      this.startControlLoadInteractive(comp.items);
    }
  },

  loadedPopupArray: [],
  doPopupOpened: function (comp) {
    if(this.loadedPopupArray.indexOf(comp.controlID) === -1) {      //载入时交互仅执行一次
      this.doStartPopupChildCompLoadInteractive(comp);
      this.loadedPopupArray.push(comp.controlID);
    }
  },

  /*
   * 开始弹出交互
   * */
  doStartPopupChildCompLoadInteractive: function (comp) {
    var i;
    var c;
    if (comp.items && comp.items.length) {
      for (i = 0; i < comp.items.length; i++) {
        c = comp.items[i];
        this.doStartCompLoadInteractive(c);
        if (c.items && c.items.length) {
          this.doStartPopupChildCompLoadInteractive(c);
        }
      }
    }
  },

  doStartCompLoadInteractive: function (comp) {
    //var index;
    //var e;
    //var entries;
    //var hasLoadInteractive = false;
    //if (comp.interactiveData) {
    //  entries = comp.interactiveData.entry;
    //  for (index = 0; index < entries.length; index++) {
    //    e = comHelper.findEventByType(comp, index, 'atLoad');   //查找指定事件类型的交互事件数据
    //    if (e) {
    //      this.interceptSelfLoad(comp, appTypes.ActionResponseType.INTERACTIVE, index);
    //      hasLoadInteractive = true;
    //    }
    //  }
    //}
    //if (hasLoadInteractive) {
    //  this.startLoadInteractiveCount++;
    //}

    //--------------------------------------------------
    // matt 2017-10-18
    // 这里改为用对像来管理组件自带延迟执行交互属性的情况
    var fun = function(comp){
      this.loadFun = null;
      this.hasLoadInteractive = function(){
        var entries;
        var e;
        var index;
        if (comp.interactiveData) {
          entries = comp.interactiveData.entry;
          for (index = 0; index < entries.length; index++) {
            e = comHelper.findEventByType(comp, index, 'atLoad');   //查找指定事件类型的交互事件数据
            if (e) {
              return true;
            }
          }
        }
        return false;
      };
      this.doStart = function(){
        var index;
        var e;
        var entries;
        if (comp.interactiveData) {
          entries = comp.interactiveData.entry;
          for (index = 0; index < entries.length; index++) {
            e = comHelper.findEventByType(comp, index, 'atLoad');   //查找指定事件类型的交互事件数据
            if (e) {
              this.loadFun(comp, appTypes.ActionResponseType.INTERACTIVE, index);
          }
          }
        }
      };
      this.start = function(){
        var interval = parseInt(comp.interval,10) || 0;
        var self = this;
        console.log(interval);
        if(interval)
          setTimeout(function(){
            self.doStart();
          },interval);
        else
          this.doStart();
      }
    };



    var f = new fun(comp);
    f.page = this;
    f.loadFun = this.interceptSelfLoad;
    if(f.hasLoadInteractive()){
      this.startLoadInteractiveCount ++;
      f.start();
    }
    //--------------------------------------------------
  },

  render: function () {
    var page = this.state.page;
    var sizeAndFix = this.computeSizeAndFix();
    var domSize = this.props.domSize;
    var normalComponents = _.filter(page.controls.control, function (comp) {
      return !comp.isCommentCom && !pageHelper.IsInvisualInteractiveCom(comp.controlTypeID);
    });
    var i;
    var comp;
    var popupComponents = [];
    if (page.controls.control) {
      for (i = 0; i < page.controls.control.length; i++) {
        comp = page.controls.control[i];
        if (pageHelper.IsInvisualInteractiveCom(comp.controlTypeID)) {
          if (comp.popup || comp.isPopupClosing) {        //Allen: 未执行完弹出面板关闭前，要显示弹出面板
          //if (comp.popup) {
            comp.onOpened = this.doPopupOpened;           //执行弹出面板的载入时交互
            popupComponents.push(comp);
          }
        }
      }
    }
    this.popupComponentsCount = popupComponents.length;
    var events = {
      doSelfClick: this.interceptSelfClick,
      doSelfDbClick: this.interceptSelfDbClick,
      doSelfRightClick: this.interceptSelfRightClick,
      doSelfLoad: this.interceptSelfLoad,
      doSelfChecked: this.interceptSelfChecked,
      doSelfLongPress: this.interceptSelfLongPress,
      onTransit: this.onTransit,
      onShowRemark: this.props.onShowRemark,
      switchOn: this.switchOn,
      switchOff: this.switchOff,
      triggerSelectExpand: this.triggerSelectExpand,
      startCompLoadInteractive: this.startCompLoadInteractive,
      startControlLoadInteractive: this.startControlLoadInteractive
    };
    var screenSize;
    var screenOrientation = this.props.page.screenOrientation;
    var appOrientation = this.props.appOrientation;
    if (screenOrientation && appOrientation && (screenOrientation !== appOrientation)) {
      screenSize = {
        width: page.defaultH,
        height: page.defaultW
      };
    } else {
      screenSize = {
        width: page.defaultW,
        height: page.defaultH
      };
    }
    this.toLoad = 1;
    if (sizeAndFix.top > 0) {
      this.toLoad += 1;
    }
    if (sizeAndFix.bottom > 0) {
      this.toLoad += 1;
    }
    return (
      <div className="page" id={this.props.page.ID}
           style={{
             backgroundColor: this.props.page.param ? this.props.page.param[0].backgroundColor : '#fff'
           }}
           onClick={this.onPageClick}>
        {sizeAndFix.top > 0 &&
        <Top
          components={normalComponents}
          top={sizeAndFix.top}
          events={events}
          onLinkClick={this.props.onLinkClick}
          onLoad={this.onLoad}
        />
        }
        <Middle
          components={normalComponents}
          screenSize={screenSize}
          pageSize={{
            width: sizeAndFix.width,
            height: sizeAndFix.height
          }}
          canFix={this.props.canFix}
          domSize={domSize}
          top={sizeAndFix.top}
          bottom={sizeAndFix.bottom}
          events={events}
          onLinkClick={this.props.onLinkClick}
          onLoad={this.onLoad}
          onPageScroll={this.onPageScroll}
        />
        {
          sizeAndFix.bottom > 0 &&
          <Bottom
            components={normalComponents}
            pageSize={{
              width: sizeAndFix.width,
              height: sizeAndFix.height
            }}
            bottom={sizeAndFix.bottom}
            events={events}
            onLinkClick={this.props.onLinkClick}
            onLoad={this.onLoad}
          />
        }
        {
          popupComponents.length > 0 && <Popup
            components={popupComponents}
            pageSize={{
              width: page.defaultW,
              height: page.defaultH
            }}
            height={page.defaultH}
            events={events}
            onLinkClick={this.props.onLinkClick}
            onLoad={this.onLoad}
            pageScrollTop={this.state.pageScrollTop || 0}
          />
        }
        {
          this.state.isShowSelectExpand &&
          <SelectComp
            {...this.state.selectProps}
          />
        }
      </div>
    );
  },

  onPageScroll: function(top, left) {
    this.setState({pageScrollTop: top});
    if(this.props.onPageScroll) {
      this.props.onPageScroll(top, left);
    }
  },

  onLoad: function () {
    this.toLoad--;
    if (this.toLoad === 0) {
      PopupHelper.init();
      delete RunTimeOptions.eventTargetCom;
      this.startAllLoadInteractive(true);
      $(ReactDOM.findDOMNode(this)).bind('onScreenClick', this.onScreenClick);
      timeLogHelper.logPageRender(this.props.page.ID, this.props.page.title, Date.now() - this.startMount);
    }
  },

  onPageClick: function (e) {
    if (this.popupComponentsCount > 0) {
      e.stopPropagation();
      e.preventDefault();
      e.nativeEvent.stopPropagation();
      PopupHelper.mousePoint = {
        x: e.pageX,
        y: e.pageY
      };
      this.doTriggerClosePopup(e);
    }
  },

  onScreenClick: function (e, me) {
    this.doTriggerClosePopup(e);
    //$('.popup-control').trigger(PopupHelper.CLOSE_POPUP_EVENT, {
    //  callback: this.doClosePopup
    //});
  },

  doTriggerClosePopup: function (e, call, noClosePopups) {
    var i;
    var c;
    var comp;
    var controls;
    var self = this;
    var finishCount = 0;
    var popupCount;
    var func = function () {
      finishCount++;
      if (finishCount !== popupCount) {
        return;
      }
      if (call) {
        call();
      }
    };
    var noClosePopupID;
    var idStr = '';
    if (noClosePopups && noClosePopups.length) {
      noClosePopupID = [];
      for (i = 0; i < noClosePopups.length; i++) {
        noClosePopupID.push(noClosePopups[i].controlID);
      }
      idStr = noClosePopupID.join(',');
    }
    if (this.state.page.controls) {
      controls = this.state.page.controls.control;
      if (controls && controls.length) {

        //c = $('.popup-control');
        //popupCount = c.length;
        //if (c.length) {
        //  for (i = 0; i < c.length; i++) {
        //    $(c[i]).trigger(PopupHelper.CLOSE_POPUP_EVENT, {
        //      callback: function (popupID) {
        //        self.doClosePopup(popupID, func)
        //      },
        //      mousePoint: {
        //        x: e.pageX,
        //        y: e.pageY
        //      }
        //    });
        //  }
        //} else {
        //  if (call) {
        //    call();
        //  }
        //}

        //popupCount = 0;
        //for(i = 0;i<controls.length;i++){
        //  comp = controls[i];
        //  if(pageHelper.IsInvisualInteractiveCom(comp.controlTypeID)){
        //    if(comp.closeWithTrigger){
        //      continue;
        //    }
        //    if(comp.popup)
        //      popupCount ++;
        //  }
        //}

        popupCount = $('.popup-control').length;
        if (noClosePopupID) {
          popupCount -= noClosePopupID.length;
        }
        if (popupCount > 0) {
          for (i = 0; i < controls.length; i++) {
            comp = controls[i];
            if (pageHelper.IsInvisualInteractiveCom(comp.controlTypeID)) {
              if (idStr.indexOf(comp.controlID) !== -1) {
                continue;
              }
              c = $('#' + comp.controlID);
              if (c.length) {
                c.trigger(PopupHelper.CLOSE_POPUP_EVENT, {
                  callback: function (popupID) {
                    self.doClosePopup(popupID, func);
                  },
                  mousePoint: {
                    x: e.pageX,
                    y: e.pageY
                  },
                  controlID: comp.controlID
                });
              }
            }
          }
        } else {
          if (call) {
            call();
          }
        }
      }
    }
    /*
     * todo mxj 下一步考虑弹出组件关闭的策略为，
     * 任何时候的点击事件，先主动冒泡到Page或者Screen中的某个事件，
     * 然后触发弹出组件的全局点击事件来关闭，而交互组件的点击需要在这个动作之后，
     * 减小回调的可能
     弹出组件中，该事件还未处理
     */
    //$('.popup-control').trigger('onScreenClick',{event:e,callback:this.doClosePopup});
  },

  doClosePopup: function (popupID, call) {
    var data = this.state.page;
    var comp;
    if (popupID) {
      comp = this.findComByID(popupID);
      if (comp) {
        comp.popup = false;
        delete comp.closeWithTrigger;
        pageHelper.updatePageComData(data, comp);
        this.refresh(data);
      }
    }
    if (call) {
      call();
    }
  },

  computeSizeAndFix: function () {
    var page = this.state.page;
    var clipArea = page.clipArea;
    var size = this.props.size;
    var width = parseInt(page.measureW, 10);
    var height = parseInt(page.measureH, 10);
    var arr;
    if (!this.props.canFix) {
      return {
        top: 0,
        bottom: 0,
        width: width,
        height: height
      };
    }
    if (!clipArea || clipArea === '(0,0,0,0)') {
      return {
        width: width,
        height: height,
        top: 0,
        bottom: 0
      };
    }
    arr = clipArea.split(',');
    return {
      width: width,
      height: height,
      top: parseInt(arr[1], 10),
      bottom: height - parseInt(arr[3], 10)
    }
  },


  getPopupTargetsBy: function (comp, index, eventType, linkKey) {
    var interactiveData = comp.interactiveData;
    var entries;
    var entry;
    var events;
    var event;
    var behaviour;
    var target;
    var i;
    var targets = [];
    if (linkKey === appTypes.ActionResponseType.INTERACTIVE) {
      if (interactiveData) {
        entries = interactiveData.entry;
        entry = entries[index];
        events = entry.events;
        if (events.event) {
          for (i = 0; i < events.event.length; i++) {
            event = events.event[i];
            if (event.eventType === eventType) {
              behaviour = event.behaviour[0];
            }
          }
        }
        if (behaviour) {
          if (behaviour.target) {
            for (i = 0; i < behaviour.target.length; i++) {
              target = behaviour.target[i];
              target = this.findComByID(target.targetID);
              if (target && pageHelper.IsInvisualInteractiveCom(target.controlTypeID)) {
                if (target.popup) {
                  targets.push(target);
                }
              }
            }
          }
        }
      }
    }
    return targets;
  },

  interceptSelfClick: function (evt, componentData, linkKey, index) {
    var self = this;
    this.doTriggerClosePopup(evt, function () {
      self.doStartInteractiveOrSkipPage(componentData, linkKey, index);
    }, this.getPopupTargetsBy(componentData, index, InteractiveType.InteractiveTypes.EventType.CLICK, linkKey));
  },

  switchOn: function (evt, componentData, linkKey, index) {
    var self = this;
    this.doTriggerClosePopup(evt, function () {
      self.doStartInteractiveOrSkipPage(componentData, 'atSwitchOn', index);
    }, this.getPopupTargetsBy(componentData, index, InteractiveType.InteractiveTypes.EventType.SWITCH_ON, linkKey));
  },

  switchOff: function (evt, componentData, linkKey, index) {
    var self = this;
    this.doTriggerClosePopup(evt, function () {
      self.doStartInteractiveOrSkipPage(componentData, 'atSwitchOff', index);
    }, this.getPopupTargetsBy(componentData, index, InteractiveType.InteractiveTypes.EventType.SWITCH_OFF, linkKey));
  },

  triggerSelectExpand: function (comboComp, props) {
    var context = this;
    if(this.expandId === props.id) {
      return;
    }
    var fun = function() {
      context.expandId = props.id;
      var rect = context.getTargetEventComAbsoluteRect(comboComp);
      var itemHeight = parseInt(props.itemHeight, 10);
      var height = itemHeight * props.dataSet.length;
      var bottomDistance = context.props.size.height - rect.bottom;
      if (height > bottomDistance) {         //下面有空间在下方显示，没有空间在空间较大一侧显示
        if(bottomDistance > rect.top) {
          props.boxStyle.top = rect.top + itemHeight
          props.boxStyle.borderTop = 'none';
        } else {
          props.boxStyle.top = rect.top - height - 1;
          props.boxStyle.borderBottom = 'none';
        }
      } else {
        props.boxStyle.top = rect.top + itemHeight
        props.boxStyle.borderTop = 'none';
      }
      props.boxStyle.height = height;
      props.boxStyle.left = rect.left;
      props.closeSelectList = context.closeSelectList;
      context.setState({isShowSelectExpand: true, selectProps: props});
    };
    if(this.isClosing) {      //等待其他下拉列表先关闭
      setTimeout(fun, 5);
    } else {
      fun();
    }

  },

  isClosing: false,
  expandId: undefined,
  closeSelectList: function () {
    var context = this;
    this.isClosing = true;
    setTimeout(function () {     //延迟，等待选中事件响应
      context.setState({isShowSelectExpand: false});
      context.isClosing = false;
      context.expandId = undefined;
    }, 5);
  },

  doStartInteractiveOrSkipPage: function (componentData, linkKey, index) {
    if (linkKey === appTypes.ActionResponseType.LINK) {
      this.interceptLinkClick(componentData.links, index);
    } else if (linkKey === appTypes.ActionResponseType.INTERACTIVE) {
      this.interceptInteractiveEvent(componentData, InteractiveType.InteractiveTypes.EventType.CLICK, index);
    } else if (linkKey === appTypes.ActionResponseType.OUTER) {
      this.interceptExternalLinkEvent(componentData);
    } else {
      this.interceptInteractiveEvent(componentData, linkKey, index);
    }
  },

  interceptSelfLongPress: function (evt, comData, index) {
    var self = this;
    this.doTriggerClosePopup(evt, function () {
      self.interceptInteractiveEvent(comData, InteractiveType.InteractiveTypes.EventType.LONG_PRESS, index);
    });
  },

  interceptSelfChecked: function (evt, componentData, isChecked, linkKey, index) {
    var eventType;
    if (_.isUndefined(index)) {
      index = 0;
    }
    var self = this;
    this.doTriggerClosePopup(evt, function () {
      if (linkKey !== appTypes.ActionResponseType.INTERACTIVE) {
        self.interceptSelfClick(evt, componentData, linkKey, index)
      } else {
        eventType = isChecked ? InteractiveType.InteractiveTypes.EventType.CHECK_TRUE : InteractiveType.InteractiveTypes.EventType.CHECK_FALSE;
        self.interceptInteractiveEvent(componentData, eventType, index);
      }
    });
  },

  interceptSelfDbClick: function (evt, comDatas, index) {
    this.interceptInteractiveEvent(comDatas, InteractiveType.InteractiveTypes.EventType.DOUBLE_CLICK, index);
  },

  interceptSelfRightClick: function (evt, comDatas, index) {
    this.interceptInteractiveEvent(comDatas, InteractiveType.InteractiveTypes.EventType.RIGHT_CLICK, index);
  },

  interceptSelfLoad: function (comDatas) {
    this.interceptInteractiveEvent(comDatas, InteractiveType.InteractiveTypes.EventType.LOAD);
  },

  interceptExternalLinkEvent: function (componentData) {
    if (componentData.externalURL) {
      var externalURL = componentData.externalURL;
      externalURL = dataHelper.decodeURIComponent(externalURL);
      if (externalURL.indexOf('http://') === -1 && externalURL.indexOf('https://') === -1) {
        externalURL = 'http://' + externalURL;
      }
      window.open(externalURL);
    }
  },


  /**
   * 拦截组件链接点击事件
   * @param links: 链接对象
   * @param index： 当前点击的链接索引序号
   */
  interceptLinkClick: function (links, index) {
    var link;
    var targetPageID;
    var animateType;
    var animateDuration;

    if (links && (index !== undefined)) {
      link = links.link[index];

      if (link && link.targetPageID && (link.linkType === appTypes.PageLinkType.PAGE_LINK)) {

        targetPageID = link.targetPageID;
        animateType = linkHelper.getLinkAnimateBySaveLinkAnimate(links.animate);
        animateDuration = parseInt(links.animateDuration, 10);
        this.setState({page: this.props.page});

        this.props.onLinkClick(targetPageID, {
          name: animateType,
          duration: animateDuration,
          timing: 'linear'
        });
      }
    }
  },


  /**
   * 拦截交互事件，同时派发组件交互事件
   * @param comDatas 组件数据
   * @param eventType 事件类型
   * @param entryIndex 响应用户事件的入口索引
   */
  interceptInteractiveEvent: function (comDatas, eventType, entryIndex) {
    this.dispatchInteractive(comDatas, eventType, entryIndex);
  },


  /***
   * 派发一个交互事件，并执行
   * @param sourceNode
   * @param eventType
   * @param entryIndex
   */
  dispatchInteractive: function (sourceNode, eventType, entryIndex) {
    interactiveManager.start(this, sourceNode, eventType, entryIndex);
  },

  refresh: function (newPage) {
    this.setState({page: newPage});
  },


  /**
   * 根据组件ID查找组件数据，该数据是从当前页面的状态数据中查找，而不是原始数据
   * @param comID 组件ID
   */
  findComByID: function (comID) {
    return pageHelper.getControlDataByComID(this.state.page, comID);
  },

  /***
   * 获取事件源组件相对于页面的绝对区域
   * @param targetDom
   * @returns {{left: number, top: number, right: number, bottom: number}}
   */
  getTargetEventComAbsoluteRect: function (targetDom) {
    var rect = {
      left: 0,
      top: 0,
      right: 0,
      bottom: 0
    };
    if (!targetDom) {
      return rect;
    }

    var pageDom = ReactDOM.findDOMNode(this);//$('#' + this.props.page.ID)[0];

    var parentDom = targetDom.parentElement;

    rect.top = targetDom.offsetTop;
    rect.left = targetDom.offsetLeft;

    //根据Dom来获取相对于page的绝对坐标
    while (parentDom !== pageDom) {
      //此处为改弹窗相对组件定位问题注释掉的，需观察是否有副作用
      //parentDom = parentDom.parentElement;
      if (parentDom) {
        rect.top += (parentDom.offsetTop - parentDom.scrollTop);
        rect.left += (parentDom.offsetLeft - parentDom.scrollLeft);
        parentDom = parentDom.parentElement;
      } else {
        break;
      }
    }
    rect.right = rect.left + targetDom.clientWidth;
    rect.bottom = rect.top + targetDom.clientHeight;
    return rect;
  },

  onTransit: function (transitions) {
    if (!_.isArray(transitions)) {
      transitions = [transitions];
    }
    this.setState({
      transitions: transitions
    });
  },

  getClipAreaScrollView: function () {
    var controls = this.state.page.controls;
    var c;
    var i;
    if (controls) {
      if (controls.control) {
        for (i = 0; i < controls.control.length; i++) {
          c = controls.control[i];
          if (c.alias === '__________________________ClidArea_______________________0000000000000000000000') {
            return c;
          }
        }
      }
    }
    return null;
  }
});

module.exports = Page;


// WEBPACK FOOTER //
// ./src/views/Page/Page.jsx